import { getFromSessionStorageWithExpiry } from '@src/quince-site-common/src/utils/getFromSessionStorageWithExpiry'
import { setInSessionStorageWithExpiry } from '@src/quince-site-common/src/utils/setInSessionStorageWithExpiry'
import { FindingMethodDetails } from '@src/telemetry/findingMethod'

const LANDING_TRACKED_KEY = 'landing_tracked'
const LANDING_TRACKED_EXPIRY_MINUTES = 180

/**
 * Checks if this is the first page view of the session and sets a guard to prevent duplicate tracking.
 * @returns 1 if this is the first page of the session (landing page), 0 otherwise
 */
export function getLandingPageFlag(): 0 | 1 {
  const hasTrackedLanding = getFromSessionStorageWithExpiry(LANDING_TRACKED_KEY)
  const isFirstPageOfSession = !hasTrackedLanding

  // Immediately set the guard for this browser session to avoid multiple 1s
  if (!hasTrackedLanding) {
    setInSessionStorageWithExpiry(LANDING_TRACKED_KEY, 'true', LANDING_TRACKED_EXPIRY_MINUTES)
  }

  return isFirstPageOfSession ? 1 : 0
}

export interface PageViewTrackingContext {
  findingMethodAggregate?: string
  findingMethodGranular?: string
  findingMethodId?: string
  landing_page: 0 | 1
}

/**
 * Builds the tracking context for page view events.
 * This is the single place to add new context fields for page view tracking.
 *
 * @param currentFindingMethod - The current finding method details
 * @returns The tracking context object for page view events
 */
export function buildPageViewTrackingContext(
  currentFindingMethod: FindingMethodDetails | undefined,
): PageViewTrackingContext {
  return {
    findingMethodAggregate: currentFindingMethod?.findingMethodAggregate,
    findingMethodGranular: currentFindingMethod?.findingMethodGranular,
    findingMethodId: currentFindingMethod?.findingMethodId,
    landing_page: getLandingPageFlag(),
  }
}
